// Actions
import { changeLocalLoading, changeErr, changeSuccess } from "../App/actions";

// Axios
import { serverAPI } from "../../index";

// Action types
export const VERIFY_EMAIL = "verify_email";

export function verifyEmail(data) {
  return function (dispatch) {
    dispatch(changeLocalLoading(true));
    return serverAPI
      .post("/user/verify-email", data)
      .then((response) => {
        dispatch(changeLocalLoading(false));
        dispatch(changeSuccess('E-mail verificado com sucesso!'));
        return response;
      })
      .catch((e) => {
        dispatch(changeLocalLoading(false));
        switch (e.response?.status) {
          case 400:
            dispatch(changeErr("Token inválido, expirado ou já utilizado."));
            break;
          case 404:
            dispatch(changeErr("Token não encontrado."));
            break;
          case 500:
            dispatch(
              changeErr(
                "Não foi possível verificar seu e-mail. Tente novamente mais tarde."
              )
            );
            break;
          default:
            dispatch(
              changeErr(
                "Desculpe, os servidores estão em manutenção no momento. Tente novamente mais tarde."
              )
            );
        }
        throw e;
      });
  };
}